import type { Word, SignVideo } from "@kys/shared-types";
import { samples, sampleUrl, samplePoster } from "./samples";

export type ShowcaseCard = { id: string; word: Word; video?: SignVideo; src?: string; poster: string };
type Request = <T>(path: string) => Promise<T>;

/** Group one backend concept across languages; supplied media has no claimed provenance or likes. */
export async function loadShowcase(query: string, request: Request): Promise<ShowcaseCard[]> {
  const term = query.trim() || "Hello";
  const words = await request<Word[]>(`words?${new URLSearchParams({ q: term, sort: "popular" })}`);
  if (!words.length) return [];
  const normalized = term.toLocaleLowerCase();
  const primary = words.find(word => [word.en, word.zh].some(label => label.toLocaleLowerCase() === normalized)) || words[0];
  const matching = words.filter(word => word.en.toLocaleLowerCase() === primary.en.toLocaleLowerCase() || word.zh === primary.zh);
  const detail = await Promise.all(matching.map(word => request<{ word: Word; videos: SignVideo[] }>(`word/${encodeURIComponent(word.id)}?page=0`)));
  const cards: ShowcaseCard[] = detail.flatMap(({ word, videos }) => videos.map(video => ({
    id: video.id, word, video, poster: `/api/media/${encodeURIComponent(video.id)}?thumbnail=1`,
  })));
  const supplied = samples.find(sample => sample[1].toLocaleLowerCase() === primary.en.toLocaleLowerCase() || sample[2] === primary.zh);
  const previewWord = matching.find(word => !!word.sample_video);
  if (supplied && previewWord) {
    for (const clip of supplied[5]) cards.push({ id: `sample-${clip}`, word: previewWord, src: sampleUrl(clip), poster: samplePoster(clip) });
  } else if (previewWord?.sample_video) {
    cards.push({ id: `sample-${previewWord.id}`, word: previewWord, src: previewWord.sample_video,
      poster: previewWord.sample_video.replace("/sample-videos/", "/sample-videos/posters/").replace(/\.mp4.*$/, ".jpg") });
  }
  return cards;
}
